import { custData } from "src/shared/services/interface";
import api from "../../../../../features/auth/axiosConfig";
import { errorHandling } from "src/shared/utils/errorHandling";
import { getLedgerByCustomer } from "src/shared/services/servicesv2";

export const getOrdersApi = (orderid: string) => {
  return api
    .get(`/app/pos/v2/order/${orderid}?pageNumber=""&pageSize=""`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("getOrdersApi Error:", err);
      throw err;
    });
};

export const getCustomerByPhoneApi = (filteredTerm: string, customerId: string | number, pagenumber: number) => {
  return api
    .get(`/app/v1/pos/customer?include_deleted=False&pageNumber=${pagenumber}&pageSize=${10}&searchBy=${filteredTerm}/${customerId}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("getCustomerByPhoneApi Error:", err);
      throw err;
    });
};

export const getLedgerByCustomerIdApi = (customerid: string) => {
  return getLedgerByCustomer(customerid)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("getLedgerByCustomerIdApi Error:", err);
      throw err;
    });
};

export const updateCustomerEmailApi = async (customerId: string, email: custData) => {
  return api
    .put(`/app/v1/pos/customer/${customerId}`, email)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      errorHandling(err);
    });
};

export const cancelOrderApi = async (
  orderid: string | undefined,
  adjustType: string,
  paymentMethod?: string
) => {
  // Build payload conditionally
  const payload: any = {
    orderStatus: "Cancelled",
  };

  // Only send adjustType if NOT Buy on Credit
  if (paymentMethod !== "Buy on Credit") {
    payload.adjustType = adjustType;
  }

  return api
    .put(`/app/pos/v2/cancel_order?orderid=${orderid}`, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("cancelOrderApi Error:", err);
      throw err;
    });
};
export const updateOrderStatusApi = (orderId: string | undefined, orderStatus: string) => {
  const order = { orderStatus: orderStatus, statusChange: true };

  return api
    .patch(`/app/pos/v2/order/${orderId}`, order)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("updateOrderStatusApi Error:", err);
      throw err;
    });
};

// export const fetchCustomerByIdApi = (customerId: string | number) => {
//   return api.get(`/app/v1/pos/customer?id=${customerId}`);
// };
